import type { PrivyClientConfig } from '@privy-io/react-auth';

export const PRIVY_APP_ID = process.env.REACT_APP_PRIVY_APP_ID || '';

export const privyConfig: PrivyClientConfig = {
  loginMethods: ['email', 'google', 'discord'],
  appearance: {
    theme: 'dark',
    accentColor: '#ffd54f',
    logo: 'https://example.com/logo.png', // Replace with actual logo
    showWalletLoginFirst: false,
  },
  embeddedWallets: {
    createOnLogin: 'off',
  },
  // Disable wallet connectors
  walletConnectCloudProjectId: undefined,
};
